import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const NavigationContainer = React.lazy(() => import("./NavigationContainer"));

const NavigationContainerLoadable = () => (
  <React.Suspense fallback={<LoadingView variation="white" />}>
    <NavigationContainer />
  </React.Suspense>
);

export default () => <NavigationContainerLoadable />;
